import { CAMPAIGN_KEYWORDS } from '../constants';

const appendPostfix = postfix => (acc, el) => ({
  ...acc,
  [`${el.key}${postfix}`]: el.value,
});

// https://blog.mixpanel.com/2015/05/11/community-tip-last-touch-utm-tags/
export default function getCampaignParams(query) {
  const keywords = CAMPAIGN_KEYWORDS.map(kw => ({
    key: kw,
    value: query[kw],
  })).filter(kw => kw.value);

  return {
    firstParams: keywords.reduce(appendPostfix(' [first touch]'), {}),
    params: keywords.reduce(appendPostfix(' [last touch]'), {}),
  };
}
